<template>
  <div class="managingPeople hp100 bbox" v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20">
        <el-form :inline="true" :model="searchInput">
          <el-col :span="2">
            <el-form-item>
              <el-button plain class="add-column-btn bbox" @click="dialogFormVisible = true" type="primary">
                <i class="el-icon-plus fw900 f16"></i> 新增</el-button>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item>
              <el-input v-model="searchInput.projectName" placeholder="请输入项目名称 " clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <!-- <el-input v-model="searchInput.businessDirectorName" placeholder="请输入商务人员名称"></el-input> -->
              <el-select v-model="searchInput.businessDirectorNameList" clearable multiple placeholder="请选择">
                <el-option v-for="item in options" :key="item.name" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-date-picker v-model="searchInput.startDate" type="date" value-format="yyyy-MM-dd" clearable
                style="width: 100%;" placeholder="付款起始时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-date-picker v-model="searchInput.endDate" type="date" value-format="yyyy-MM-dd" clearable
                style="width: 100%;" placeholder="付款结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-select v-model="searchInput.type" placeholder="请选择类型" clearable>
                <el-option v-for="item in moneyType" :key="item.type" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <el-button type="primary" style="margin-left: 20px" @click="search()">搜索</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <!-- 用户列表区域 -->
      <div>
        <el-table :data="tableData" border fit show-summary highlight-current-row style="width: 100%"
          :height="height + 'px'" @sort-change="sortChange" ref="tableRef" :summary-method="summaryMethod">
          <el-table-column label="项目名称" align="center" prop="projectName" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.projectName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="付款期数" align="center" prop="付款期数" width="70">
            <template slot-scope="scope">
              <span>{{ scope.row.payTimes }}</span>
            </template>
          </el-table-column>
          <el-table-column label="付款金额" align="center" sortable prop="payAmount" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.payAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商务人员" align="center" prop="商务人员名称">
            <template slot-scope="scope">
              <span>{{ scope.row.businessDirectorName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="剩余金额" align="center" prop="surplusAmount" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.surplusAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="合同总金额" align="center" prop="projectAmount" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.projectAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="回款类型" align="center" prop="回款类型">
            <template slot-scope="scope">
              <span>{{
                scope.row.type == "1"
                  ? "项目回款"
                  : scope.row.type == "2"
                    ? "居间费"
                    : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="打款时间" align="center" prop="打款时间" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.payDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="center" prop="创建时间" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.createDt }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center" prop="备注" width="230">
            <template slot-scope="scope">
              <span>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column label="付款方式" align="center" prop="付款方式" width="70">
            <template slot-scope="scope">
              <span>{{
                scope.row.payType == "1"
                  ? "微信"
                  : scope.row.payType == "2"
                    ? "支付宝"
                    : scope.row.payType == "3"
                      ? "对公打款"
                      : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage" :page-sizes="[50, 100, 300]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </el-card>
    <!-- 新增弹窗 -->
    <el-dialog title="新增: " :visible.sync="dialogFormVisible" style="width: 100%; margin: 0 auto; padding: 20px"
      @close="cancelSubmit" width="78%">
      <el-row :gutter="24" style="padding-top: 20px; padding-left: 20px">
        <el-form :inline="true" :model="searchInput2">
          <el-form-item label="项目名称">
            <el-input v-model="searchInput2.projectName"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-left: 20px" @click="search2">查询</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <div class="tableBox">
        <el-table :data="moneyTypeData" border style="width: 100%" :header-cell-style="{ background: '#f7f7f7' }"
          @row-dblclick="dbclick">
          <el-table-column prop="type" label="类型（回款1，居间费2）" align="center">
            <template slot-scope="scope">
              <div style="display: flex">
                <span style="color: red">*</span>
                <el-input v-if="scope.row.isOK" v-model="scope.row.type"></el-input>
                <span v-else>{{ scope.row.type }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="payAmount" label="收款金额" align="center">
            <template slot-scope="scope">
              <div style="display: flex">
                <span style="color: red">*</span>
                <el-input v-if="scope.row.isOK" v-model="scope.row.payAmount"></el-input>
                <span v-else>{{ scope.row.payAmount }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="payTimes" label="收款期数" align="center">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isOK" v-model="scope.row.payTimes"></el-input>
              <span v-else>{{ scope.row.payTimes }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="payType" label="支付方式" align="center">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isOK" v-model="scope.row.payType"></el-input>
              <span v-else>{{ scope.row.payType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="payDate" label="打款时间" align="center" width="280">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isOK" v-model="scope.row.payDate"></el-input>

              <span v-else>{{ scope.row.payDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="payDate" label="创建时间" align="center" width="280">
            <template slot-scope="scope">
              <el-date-picker v-if="scope.row.isOK" v-model="scope.row.createDt" type="date" placeholder="选择日期">
              </el-date-picker>
              <span v-else>{{ scope.row.createDt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createorName" label="收款人" align="center">
            <template slot-scope="scope">
              <div style="display: flex">
                <span style="color: red">*</span>
                <el-input v-if="scope.row.isOK" v-model="scope.row.createorName"></el-input>
                <span v-else>{{ scope.row.createorName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="businessDirectorName" label="业务人员" align="center">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isOK" v-model="scope.row.businessDirectorName"></el-input>
              <span v-else>{{ scope.row.businessDirectorName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center">
            <template slot-scope="scope">
              <el-input v-if="scope.row.isOK" v-model="scope.row.remark"></el-input>
              <span v-else>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tableBox">
        <el-table :data="projectMoneyData" border style="width: 100%" :header-cell-style="{ background: '#f7f7f7' }"
          @row-click="singleElection">
          <el-table-column width="65">
            <template slot-scope="scope">
              <el-radio class="radio" v-model="templateSelection" :label="scope.$index">&nbsp;&nbsp;</el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="projectName" label="项目名称" align="center">
          </el-table-column>
          <el-table-column prop="projectAmount" label="合同金额" align="center">
          </el-table-column>
          <el-table-column prop="payAmount" label="已付金额" align="center">
          </el-table-column>
          <el-table-column prop="surplusAmount" label="未付金额" align="center">
          </el-table-column>
          <el-table-column prop="createDt" label="上一期付款时间" align="center">
          </el-table-column>
          <el-table-column prop="payAmount" label="上一期付款金额" align="center">
          </el-table-column>
          <el-table-column prop="payPeriods" label="已付期数" align="center">
          </el-table-column>
          <el-table-column prop="projectApprovalTime" label="立项日期" align="center">
          </el-table-column>
        </el-table>
      </div>
      <div class="twobtn" style="width: 200px; margin: 20px auto">
        <el-button type="primary" style="margin-right: 20px" @click="submitCurrrow">确认</el-button>
        <el-button @click="cancelSubmit">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight - 180, //表格高度
      value: "",
      searchInput: {
        projectName: "",
        businessDirectorName: "",
        startDate: "",
        endDate: "",
        type: "",
      },
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 300,
        //查询条件
        condition: {
          id: "",
          type: "",
        },
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: "",
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
      // ---------------------------------
      moneyType: [
        {
          value: "1",
          label: "回款",
        },
        {
          value: "2",
          label: "居间费",
        },
      ],
      dialogFormVisible: false,
      searchInput2: {
        projectName: "",
      },
      moneyTypeData: [
        {
          type: "",
          payAmount: "",
          payTimes: "",
          payType: "",
          payDate: "",
          createorName: "",
          businessDirectorName: "",
          remark: "",
          isOK: true,
        },
      ],
      projectMoneyData: [],
      // 选中的行
      templateSelection: "0",
      templateRadio: "",
      currRow: {},
      options: [],
    };
  },
  created() {
    this.getUserList();
    this.queryInfo.currPage = this.$route.query.currPage;
    this.getListData();
    window.addEventListener("resize", this.getHeight);
    var that = this;
    document.onkeydown = function (e) {   //按下回车提交
      let key = window.event.keyCode;
      //事件中keycode=13为回车事件
      if (key == 13) {
        that.getListData();
      }
    };
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    // 编辑
    edit(id) {
      this.dialogFormVisible = true;
      this.$http.post('/paymentReceivable/queryOne', {
        id
      }).then(res => {
        console.log(res.data)
        if (res.data.code === 200) {
          res.data.data.isOK = true
          this.moneyTypeData = [res.data.data]
          this.searchInput2.projectName = res.data.data.projectName;
          this.search2();

        }
      })
    },
    //条件查询
    search() {
      this.queryInfo.condition = this.searchInput;
      this.getListData();
    },
    // 弹窗里的条件查询
    search2() {
      if (this.searchInput2.projectName == '') {
        this.$notify.error({
          title: "提示",
          message: "请输入项目名称",
          showClose: true,
        });
        return
      }
      var that = this;
      let data = {};
      data.projectName = that.searchInput2.projectName;
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      that.$http
        .post("/project/queryProjectByName", data)
        .then(function (response) {
          console.log("弹窗table===>", response.data.data);
          if (response.data.code == 200) {
            that.projectMoneyData = response.data.data;
            for (let i = 0; i < response.data.data.length; i++) {
              that.projectMoneyData[i].createDt = that.timeFormate(
                response.data.data[i].createDt
              );
              that.projectMoneyData[i].projectApprovalTime = that.timeFormate(
                response.data.data[i].projectApprovalTime
              );
            }
          }
        }).then(() => {
          this.singleElection(this.projectMoneyData[0])
        })
    },
    dbclick(row, event, column) {
      // row.isOK = !row.isOK;
    },
    //只能选择一行，选择其他，清除上一行
    singleElection(row) {
      console.log("当前选中行===>", row);
      this.currRow = row;
      this.templateSelection = this.projectMoneyData.indexOf(row);
      console.log("this.templateSelection==>", this.templateSelection);
      this.templateRadio = row.id;
    },
    // 取消保存
    cancelSubmit() {
      this.dialogFormVisible = false;
      this.moneyTypeData = [
        {
          type: "",
          payAmount: "",
          payTimes: "",
          payType: "",
          payDate: "",
          createorName: "",
          businessDirectorName: "",
          remark: "",
          isOK: true,
        },
      ];
      this.projectMoneyData = [];
      this.searchInput2.projectName = "";
      this.templateSelection = ''
    },
    // 确定选择当前行
    submitCurrrow() {
      if (this.templateRadio == '') {
        this.$notify.error({
          title: "提示",
          message: "请选择项目",
          showClose: true,
        });
        return;
      }
      if (
        this.moneyTypeData[0].type == "" ||
        this.moneyTypeData[0].payAmount == "" ||
        this.moneyTypeData[0].createorName == ""
      ) {
        this.$notify.error({
          title: "提示",
          message: "必填项未填写完整",
          showClose: true,
        });
        return;
      }
      var that = this;
      let data = {};

      // debugger
      data.projectCode = that.currRow.projectCode;
      data.type = that.moneyTypeData[0].type;
      data.payAmount = that.moneyTypeData[0].payAmount;
      data.payTimes = that.moneyTypeData[0].payTimes;
      data.payTypeStr = that.moneyTypeData[0].payType;
      data.payDate = that.moneyTypeData[0].payDate;
      data.createDt = that.moneyTypeData[0].createDt;
      data.createorName = that.moneyTypeData[0].createorName;
      var businessDirectorName = that.moneyTypeData[0].businessDirectorName;
      if (!businessDirectorName) {
        businessDirectorName = localStorage.getItem("name");
      }
      data.businessDirectorName = businessDirectorName;
      data.remark = that.moneyTypeData[0].remark;
      data.id = that.moneyTypeData[0].id;
      console.log("data===>", that.moneyTypeData);
      data.userCode = JSON.parse(localStorage.getItem("userCode")).value;
      that.$http
        .post("/paymentReceivable/savePaymentReceivableEvent", data)
        .then(function (response) {
          console.log("保存接口==>", response.data.data);
          if (response.data.code == 200) {
            that.dialogFormVisible = false;
            that.getListData();
            that.moneyTypeData = [
              {
                type: "",
                payAmount: "",
                payTimes: "",
                payType: "",
                payDate: "",
                createorName: "",
                businessDirectorName: "",
                remark: "",
                isOK: true,
              },
            ];
            that.projectMoneyData = [];
            that.searchInput2.projectName = "";
            that.templateSelection = "";
          }
        });
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() { },
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/paymentReceivable/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize,
        },
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
        queryInfo
        var that = this;
        that.$http
          .post("/paymentReceivable/delete", { id: id })
          .then(function (response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true,
            });
            that.getListData();
          });
      }
    },
    // 获取列表
    getListData() {
      var that = this;
      that.queryInfo.condition.userCode = JSON.parse(
        localStorage.getItem("userCode")
      ).value;
      that.$http
        .post("/paymentReceivable/list", that.queryInfo)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
            console.log("table===>", that.tableData);
            for (let i = 0; i < that.tableData.length; i++) {
              that.tableData[i].createDt = that
                .timeFormate(response.data.data.data[i].createDt)
                .substr(0, 11);
              that.$nextTick(() => {
                that.$refs.tableRef.doLayout();
              })
            }
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 200;
    },
    // 时间格式化
    timeFormate(originVal) {
      const dt = new Date(originVal);

      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");

      const hh = (dt.getHours() + "").padStart(2, "0");
      const mm = (dt.getMinutes() + "").padStart(2, "0");
      const ss = (dt.getSeconds() + "").padStart(2, "0");
      // yyyy-mm-dd hh:mm:ss
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },

    // 合计行只保留两位小数
    summaryMethod(params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        // 这里可以指定哪些字段需要合计，哪些需要格式化小数，示例针对金额相关的字段处理。
        if (
          ['payAmount', 'surplusAmount', 'projectAmount'].includes(column.property)
        ) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            const total = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + value;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = total.toFixed(2);
          } else {
            sums[index] = '';
          }
        } else if (index === 0) {
          sums[index] = '合计';
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },

    getUserList() {
      var that = this;
      var data = {};
      data.type = "1";

      that.$http
        .post("/userInfo/queryList", data)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.options = response.data.data;
          }
        });
    }
  },

};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}

.managingPeople {

  .el-col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .el-form-item--small.el-form-item {
    margin-bottom: 5px !important;
  }

  .el-card {
    height: calc(100vh - 90px);
    position: relative;

    /deep/.el-card__body {
      padding: 0 20px 10px 20px !important;
    }

    .el-select>.el-input {
      width: 200px;
    }

    .header-search-box .header-search-input {
      width: 325px;
    }

    input::placeholder {
      font-size: 12px;
    }

    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }

    // .footerBox {
    //   position: absolute;
    //   width: 100%;
    //   height: 78px;
    //   left: 20px;
    //   right: 20px;
    //   bottom: 0;
    // }
  }
}

/deep/.el-scrollbar__view {
  min-width: 100%;
}

/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}

/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}

/deep/.el-dialog__body {
  padding: 20px;
}
</style>